import React from 'react';
import { useSelector } from 'react-redux';

import type { HeaderCopyBlockProps } from 'src/components/organisms/HeaderCopyBlock/HeaderCopyBlock';
import { HeaderCopyBlock } from 'src/components/organisms/HeaderCopyBlock/HeaderCopyBlock';
import { selectHeaderCopyBlockContent } from 'src/redux/content/selectors/selectHeaderCopyBlockContent';
import trackSEOCopyLinkClick from 'src/tracking/events/SEOCopyLinkClick';
import { trackSEOCopyToggle } from 'src/tracking/events/seoCopyToggle';

export const HeaderCopyBlockContainer = () => {
  const { description, heading, subheading } = useSelector(selectHeaderCopyBlockContent);

  if (!heading) {
    return null;
  }

  const props: HeaderCopyBlockProps = {
    description,
    heading,
    subheading,
    onAccordionToggle: ({ open }) => {
      trackSEOCopyToggle({ open, heading });
    },
    onDescriptionLinkClick: trackSEOCopyLinkClick,
  };

  return <HeaderCopyBlock {...props} />;
};
